import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TableConfig } from '../../../../../../shared/util/table-config.utils';
import { Log } from "ng2-logger";

@Component({
    selector: 'app-lines-table',
    templateUrl: './lines-table.component.html',
    styleUrls: ['./lines-table.component.scss']
})
export class LinesTableComponent {
    _logger = Log.create(LinesTableComponent.name);
    @Input() lines = [];
    @Input() userRoles = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = true;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() rowClick = new EventEmitter<any>();
    @Output() duplicateRow = new EventEmitter<any>();

    onPageChange(tableConfig: TableConfig) {
        this._logger.info('onPageChange::', tableConfig);
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this._logger.info('onSortChange::', tableConfig);
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this._logger.info('onFilterChange::', tableConfig);
        this.filterChange.emit(tableConfig);
    }

    onRowClick(clickedItem) {
        this._logger.info('onRowClick::', clickedItem);
        this.rowClick.emit(clickedItem);
    }

    onDuplicateRow(duplicateRow) {
        this._logger.info('onDuplicateRow::', duplicateRow);
        this.duplicateRow.emit(duplicateRow);
    }

}
